import type { FC } from 'react';

import { useIsFeatureVisibleToOrg } from '@/utils/featureFlags';

import { LineChartWidgetCloudscape } from './LineChartWidget.cloudscape';
import { LineChartWidgetHighcharts } from './LineChartWidget.highcharts';

export type Props = {
  loading?: boolean;
  xTitle: string;
  yTitle: string;
  values?: { x: Date; y: number }[];
  series?: { name: string; data: { x: string; y: number }[] }[];
  tooltipYValueFormatter?: (
    y: number | undefined,
    seriesIndex: number
  ) => string;
  pointColorFormatter?: (
    y: number | undefined,
    seriesIndex: number
  ) => string | undefined;
};

const LineChartWidget: FC<Props> = (props) => {
  const highchartsEnabled = useIsFeatureVisibleToOrg('highcharts');

  if (highchartsEnabled) {
    return <LineChartWidgetHighcharts {...props} />;
  }

  return <LineChartWidgetCloudscape {...props} />;
};

export default LineChartWidget;
